import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { filtersApply, filtersExtendedApply, filtersReset } from 'Modules/SearchModule/actions'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    extendedFilters: selectors.extendedFilters(state),
    filters: selectors.filters(state),
    statusOptions: selectors.statusOptions(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    applyExtendedFilters: filters => dispatch(filtersExtendedApply(filters)),
    applyFilters: filters => dispatch(filtersApply(filters)),
    resetFilters: () => dispatch(filtersReset()),
  })

  Enhancer.displayName = 'SearchFormEnhancer'

  Enhancer.propTypes = {
    applyExtendedFilters: PropTypes.func.isRequired,
    applyFilters: PropTypes.func.isRequired,
    extendedFilters: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    statusOptions: PropTypes.array.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
